// import * as Assets from '../../src/Assets/Assets'
import {Logic} from './Type'

export class LoginState extends Logic.Type {
    Verified: boolean = false
    Balance: string
    Username:string = ''
    PasswordIncorrect:boolean = false
    // Currency: string = Assets.CurrencyEUR
    UsernameEmpty: boolean = false
/*
    token: string
    Password:string = ''
    Mail:string = ''
    Name:string
    PlayerExists:boolean = false
    Mode:boolean = false
    AccountJustCreated:number = 0
    GameMode = false
    IframeLink: string
    IframeBackground: string
    BalanceAdd : number = 10
    XpAdd: number = 100
    // Deposit:string = Assets.Deposit
    ViewLarge:boolean = false

    Progress:number = undefined
    SelectionBigMenu:number = 0
    SelectionMenu:number = 0
    SelectionBanner:number = 1
    MobileMenuOpen:boolean = false
*/
}


// WEBPACK FOOTER //
// ./src/Logic/Login.ts